
export type CreateOrderSession401 = {
  code?: string;
  error: string;
  success: boolean;
  timestamp?: string;
};
